// DS: STU3.8
import type { CSSProperties, FC } from 'react';

import { useContext } from 'react';
import cn from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import HoverableWrapper from '@wix/da-ds/pkg/thumbs/OverlayHelpers/HoverableWrapper';
import StandardThumb from '@wix/da-shared-react/pkg/DeviationViews/Thumb/Standard';
import ThumbOverlay from '@wix/da-shared-react/pkg/DeviationViews/Thumb/legos/Overlay';
import { useOverlayContext } from '@wix/da-shared-react/pkg/DeviationViews/hooks/useOverlayContext';
import DeviationMediaService from '@wix/da-shared-react/pkg/utils/DeviationMediaService';
import StudioThumbMobile from './StudioThumbMobile';
import StudioNoPreviewThumb from './lego/StudioNoPreviewThumb';

import s from './StudioThumb.scss';

export interface Props {
  deviation: PapiDeviation;
  width?: number;
  height?: number;
  style?: CSSProperties;
  className?: string;
}

const StudioThumb: FC<Props> = props => {
  const isMobile = useContext(MobileContext);
  const { __forceHoveredForStories } = useOverlayContext(props.deviation);

  if (isMobile) {
    return <StudioThumbMobile {...props} />;
  }

  const { deviation, width, height, style, className } = props;
  const filetype = DeviationMediaService.getMediaFileType(deviation);

  if (filetype !== 'freeform' && deviation.isDefaultImage) {
    return (
      <HoverableWrapper
        className={cn(s['no-preview-wrapper'], className)}
        style={{
          width,
          height,
          ...style,
        }}
        __forceHoveredForStories={__forceHoveredForStories}
      >
        <StudioNoPreviewThumb deviation={deviation} width={width} height={height} />
        <ThumbOverlay
          deviation={deviation}
          width={width}
          height={height}
          className={s['overlay']}
          aria-hidden="true"
        />
      </HoverableWrapper>
    );
  }

  return (
    <StandardThumb
      deviation={deviation}
      width={width}
      height={height}
      style={style}
      canLinkToStash
    />
  );
};
StudioThumb.displayName = 'StudioThumb';

export default StudioThumb;
